import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from '../../static/images/logo-countpicula-dark.png';
import { Table } from 'react-bootstrap';
import withRouter from 'react-router-dom/withRouter';
import { Col } from 'react-bootstrap';

class UserReceiptView extends Component {
  state = {
    receipt: {}
  };

  componentDidMount() {
    document.body.style = 'background: none; color: black;';
    const key = 'receipts';
    if (localStorage[key]) {
      let receipt = localStorage.getItem(key);
      receipt = JSON.parse(receipt);
      this.setState({
        receipt
      });
      localStorage.removeItem(key);
    }
  }

  render() {
    const { receipt } = this.state;
    if (Object.keys(receipt).length) {
      const {
        date,
        itemPurchased,
        paymentId,
        subtotal,
        tax,
        userAddress
      } = this.state.receipt;
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const dateFormatted = new Date(date).toLocaleString('en-GB', options);
      return (
        <div style={{ margin: '20px' }}>
          <img className="logo-img" src={logo} width="117" height="75" alt="" />
          <h1>Invoice</h1>
          <p>Invoice date: {dateFormatted}</p>
          <p>Invoice number: {paymentId}</p>
          <div>
            <h2>Issued by: </h2>
            <h3>Count Picula</h3>
            <p>trading as Isotoma</p>
            <p>Swinegate Court East</p>
            <p>Swinegate </p>
            <p>York </p>
            <p>YO1 8AJ </p>
            <p>VAT Number: GB843570325</p>
          </div>
          <h2>Issued to: </h2>
          <h3>{userAddress.recipient_name}</h3>
          <p>{userAddress.line1}</p>
          {userAddress.line2 && <p>{userAddress.line2}</p>}
          <p>{userAddress.city}</p>
          <p>{userAddress.postal_code}</p>
          <h2>Charges:</h2>
          <Col xs={6} md={4}>
            <Table condensed>
              <tbody>
                <tr>
                  <th className="col-desc">Description</th>
                  <td className="col-desc">{itemPurchased}</td>
                </tr>
                <tr>
                  <th className="col-exvat">Subtotal</th>
                  <td className="col-desc">£{(+subtotal).toFixed(2)}</td>
                </tr>
                <tr>
                  <th className="col-exvat">VAT</th>
                  <td className="col-desc">£{(+tax).toFixed(2)}</td>
                </tr>
                <tr>
                  <th className="col-total">Total</th>
                  <td className="col-total">
                    £{(+subtotal + +tax).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <th className="col-total">Paid</th>
                  <td className="col-total">
                    £{(+subtotal + +tax).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </div>
      );
    } else {
      return (
        <div style={{ margin: '20px' }}>
          <img className="logo-img" src={logo} width="117" height="75" alt="" />
          <h1>No invoice found</h1>
          <p>Return to Your Orders and try again</p>
        </div>
      );
    }
  }
}

const UserReceipt = withRouter(connect()(UserReceiptView));
export default UserReceipt;



// WEBPACK FOOTER //
// ./src/comps/Receipts/UserReceipt.js